module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Capitolo 1")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("P")]), _vm._v("er quanto Miss Jane")]), _vm._v(" Featherstone adorasse la sua bella cugina, Lady Sarah Bertram, non le piaceva affatto andare a Hyde Park con lei in questa bella giornata di maggio. Non per colpa di Lady Sarah, ma per l’imperdonabile gelosia di Miss Featherstone. La sua invidia clandestina era decisamente illogica (e Miss Jane Featherstone si era sempre vantata della sua capacità di padroneggiare i principi della logica).")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non era che qualcuna delle Più Appetibili Conquiste Matrimoniali avrebbe dato una seconda occhiata a Miss Featherstone, estremamente scialba, se non ci fosse stata l’abbagliante Lady Sarah appollaiata accanto a lei.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nei dieci minuti trascorsi da quando il baraccone aperto delle fanciulle aveva varcato i cancelli per entrare nel parco, non meno di cinque giovani uomini titolati, di bell’aspetto e amabili avevano fermato i loro cavalli per fare la corte a Lady Sarah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E non c’era da stupirsi. Una volta che sua cugina fosse stata presentata al "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ton")]), _vm._v(" al ballo di stasera, ogni Appetibile Conquista Matrimoniale dell’intero regno si sarebbe scagliata contro la bellissima ragazza. Con capelli del colore del grano che scintillavano al sole, un viso impeccabile e liscio come la più bella perla e una figura che si incurvava come quella di una dea romana, Lady Sarah sarebbe salita senza sforzarsi in cima al gruppo delle debuttanti di questa stagione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando si scoprì che la bellezza titolata possedeva una delle più grandi fortune della Gran Bretagna, non ci sarebbe stato modo di fermare la corsa a Casa Clegg a Berkley Square.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Poiché la bella ereditiera non era stata ancora presentata, i giovani curiosi non poterono iniziare direttamente una conversazione con lei finché Miss Featherstone non ebbe la bontà di facilitare le presentazioni.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Pertanto, Miss Featherstone è stata – per la prima volta dalla sua presentazione avvenuta tre anni prima – l’oggetto delle profonde felicitazioni dei giovani uomini. Una volta scambiati i saluti, Miss Featherstone non ha avuto altra scelta che presentare queste persone al suo spettacolare compagno.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("E poi Miss Featherstone sarebbe svanita silenziosamente nella tappezzeria come vernice grigia sulla latta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lasciando il giovane Lord Averworth a guardare con venerazione Lady Sarah che proseguiva lungo l’ampio viale del parco, la bella si rivolse alla cugina, con gli occhi azzurri che lampeggiavano dall’amozione. “Tutti i giovani che ho incontrato sono estremamente gentili. Non vedo l’ora che arrivi stasera”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oserei dire che sarai come una regina che tiene banco”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mi farete arrossire”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Le assicuro che non è questo il mio intento. Non vorremmo che il rossore rovinasse la sua bella carnagione”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah era troppo onesta per fingere una modestia da fanciulla. Non era passato giorno della sua vita in cui la sua notevole bellezza non fosse stata commentata. “Nemmeno io. Ecco perché oggi indosso questa orrenda cuffietta a tesa larga”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Miss Featherstone scosse la testa. “La vostra cuffietta non è orrenda. Tutto ciò che indossate è segno di un gusto impeccabile”. In effetti, pensò Miss Featherstone, non aveva mai visto una cuffietta più bella. Mentre la maggior parte delle signore di sua conoscenza cambiava le rifiniture delle cuffiette per coordinarle con l’abbigliamento, l’intera cuffietta di Lady Sarah si abbinava perfettamente al giallo pallido del suo abito da mattina. Aveva forse il lusso di avere una cuffietta di colore diverso per ogni abito?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ti piace davvero tanto l’abito che indosserò stasera?” chiese Lady Sarah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sì, anche se oserei dire che se indossassi una coperta da cavallo saresti comunque la ragazza più bella del ballo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sei troppo gentile, mia dolce Jane”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Miss Featherstone sospirò. “Vorrei poter essere più gentile con Lavinia”. Aveva pregato inutilmente che lei e la moglie di suo fratello andassero più d’accordo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah spalancò gli occhi. “Quell’orribile donna è davvero odiosa! Non capirò mai come tuo fratello abbia potuto scegliere di sposarla”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“La sua generosa dote è stata d’auto”. Purtroppo nessuno dei Featherstone aveva... beh, una "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("piuma")]), _vm._v(" con cui volare.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allora probabilmente non la ama affatto. È questo il problema quando si possiede la fortuna. Non si sa mai se un gentiluomo è innamorato di lei o dei suoi soldi”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Se non l’amava quando si sono sposati, credo che l’ami adesso, ma non dovete temere i cacciatori di dote”, assicurò Miss Featherstone. “Gli uomini si innamorerebbero di voi anche se foste povera come... beh, come me”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“La vostra mancanza di fortuna spiega perché non avete ricevuto offerte, perché possedete molti attributi”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Miss Featherstone si aggiustò la tesa della cuffia per ripararsi gli occhi dal sole cocente. “Di grazia, mia cara cugina, illuminatemi su questi attributi”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non sarai bella come me, ma sei davvero graziosa. In un modo tranquillo”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Evidentemente hai frequentato troppo mio padre”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Questo non ha nulla a che fare con la mia opinione, te l’assicuro. Ho una buona vista. Il tuo viso è bello. Siete terribilmente intelligente. E non c’è nulla di offensivo nella vostra figura”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Se uno è portato ad ammirare le aste per bandiere”. Miss Featherstone fece un cenno ad un paio di ragazze ridacchianti che passeggiavano, con gli ombrellini che proteggevano i loro bei visi dal sole.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Molti uomini preferiscono le donne snelle. Ricordate che sono le donne come me, quelle con doti generose, a diventare corpulente con l’età”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questo è vero. Ma, d’altronde, molti uomini preferivano le donne corpulente. Guardate il Reggente stesso! La maggior parte delle donne con cui era stato legato sentimentalmente tendevano ad essere rotonde come lui.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mentre seguivano il corteo di belle carrozze verso un boschetto di alberi, Miss Featherstone si beava del calore del sole, mentre i suoi pensieri serpeggiavano intorno alla sua abominevole invidia. Non c’era motivo di sentirsi in competizione con Lady Sarah. Amava sua cugina e sapeva che non avrebbe mai potuto competere con lei nelle alte sfere della società.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Miss Featherstone aveva sempre capito che il suo futuro sarebbe stato con un uomo altrettanto semplice e non particolarmente distinto. Il problema era che nemmeno un uomo semplice e non particolarmente distinto aveva mai onorate Jane Featherstone con una proposta di matrimonio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il che era un peccato. Papà aveva quasi settant’anni, e quando se ne fosse andato, Jane sarebbe diventata la zia di peso nella famiglia del fratello e di Lavinia, una prospettiva tanto sgradita a Lavinia quanto a Jane.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando la loro carrozza si avvicinò a Serpentine, le sembrò di riconoscere Lord Slade che cavalcava da solo. La sua schiena si raddrizzò. Lo sguardo si restrinse. E quando si rese conto che lui stava cavalcando verso di loro, il battito del suo cuore si infranse contro le pareti del suo petto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sin dal giorno in cui Miss Jane Featherstone era uscita dall’aula scolastica, aveva segretamente venerato quell’uomo. Molto prima che lui succedesse al titolo, aveva ammirato le sue brillanti orazioni alla Camera dei Comuni. Il suo caro papà era uno dei più strenui alleati di Lord Slade con il bestiale Tories. Aveva riempito un libro con i resoconti dei giornali su sua signoria e l’aveva nascosto in un cassetto sotto il portagioie.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non solo lei amava enormemente la sua intelligenza e filosofia politica, ma lei pensava anche che lui fosse forse l’uomo più fisicamente attraente che avesse mai visto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Certo, probabilmente non si sarebbe ricordato di una persona così semplice come lei. Prima di passare alla Camera dei Lord alla morte del padre, era venuto spesso a casa loro per discutere di riforme politiche con il padre ed i loro colleghi alla Camera dei Comuni.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dato che lei era la padrona di casa del padre e che quest’ultimo assecondava la sua unica figlia, Miss Featherstone aveva avuto il permesso di partecipare a quelle conversazioni.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando Lord Slade si avvicinò, i sui occhi si soffermarono su Lady Sarah, poi su Jane ed un sorriso di riconoscimento illuminò il suo volto abbronzato. Santo cielo! Quest’uomo si sarebbe fermato a parlare con loro. Lei fremeva così tanto che dubitava di essere in grado di evocare la sua voce.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’autista con la livrea scarlatta si fermò quando vide che Lord Slade si era fermato.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Buon pomeriggio, Miss Featherstone. Vedo che anche lei si sta godendo questa bella giornata di sole”. Dalle sue spalle larghe, ai piani squadrati del viso, ai capelli castano intenso gettati con disinvoltura, quell’uomo emanava la mascolinità più robusta che lei avesse mai visto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Rifuggiva dagli orpelli dei dandy e vestiva in abiti da cavallerizzo, senza cappello a cilindro né stivali luccicanti. I suoi calzoni color bufalo si estendevano su gambe lunghe e muscolose ed i suoi stivali marroni sarebbero stati più appropriati in campagna che qui al centro di Londra. Il fatto che non fosse schiavo della moda lo rendeva ancora più simpatico a Miss Featherstone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Infatti, mio signore”, riuscì a dire, grata che la sua voce non avesse tradito il rantolo che aveva dentro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Egli annuì, poi i suoi occhi neri e lampeggianti scrutarono Lady Sarah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane capì che si aspettava una presentazione dell’Incomparabile. “Lord Slade, posso presentarvi mia cugina, Lady Sarah Bertram?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah regalò il suo brillante sorriso al suo ultimo ammiratore e si scambiarono i saluti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dopo avere detto tutto il necessario, Lord Slade rivolse nuovamente la sua attenzione a Miss Featherstone. “Allora voi due siete parenti da parte di madre? Lady Mary non era forse sorella del Conte di Clegg?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se la madre defunta di Miss Featherstone – la Lady Mary a cui si era appena riferito Lord Slade – fosse apparsa in questo percorso tortuoso, Jane non avrebbe potuto essere più stupita. Lord Slade aveva ricordato che sua madre era figlia di un conte. “Sì. Il Conte di Clegg – che è il fratello di mia madre – è il padre di Lady Sarah”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allora siete la nipote di George Berkley?” egli disse a Lady Sarah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tutti nel "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ton")]), _vm._v(" sapevano che l’ingente fortuna bancaria di George Berkley era stata affidata alla sua prima nipote, che si dava il caso fosse la stupefacente creatura seduta lì, nella carrozza del padre, a Hyde Park.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah sorrise. “Era vero. Lo conoscevate?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane pensò che le lunghe ciglia di sua cugina le scendevano sulle guance. Si può essere più belli? Una fitta di gelosia le serpeggiò dentro. Che peccato bestiale che Jane non potesse mai apparire in modo così vantaggioso a sua signoria.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non ho avuto questo piacere, ma era il banchiere di mio padre – che lo ammirava molto”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Anch’io”, disse Lady Sarah, alzando la voce nei toni più dolci possibile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ditemi, mia signora, perché non vi ho ancora incontrata prima?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non sono stata presentata. Beh, in realtà sono stata presentata alla regina ieri”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“E lei stasera esce”, aggiunse Jane. “Parteciperete al ballo a Casa Spencer, mio signore?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il suo sorriso storto ritornò. “Potete stare certi che lo farò”. Lui si tolse un berretto invisibile, li favorì con il suo sorriso contagioso e si congedò.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando fu fuori dalla portata delle orecchie, Jane si rivolse a sua cugina. “Che cosa ne pensi di Lord Slade?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah alzò le spalle. “Non ho pensato a lui né in un senso né nell’altro. Devo ammettere che ero pronta a non sopportarlo più di tanto. Papà, sapete, detesta i suoi modi radicali in Parlamento. Si lamenta sempre di Lord Slade”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allora oserei dire che anche lo zio brontola contro papà, perché lui e Lord Slade sono proprio due gocce d’acqua”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Non è un segreto, naturalmente, che papà e tuo padre non siano d’accordo su questioni di governo, ma tuo padre è della famiglia, quindi papà non lo maligna mai”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I signori sono molto più gentili delle signore”. Come poteva Lady Sarah non essere in soggezione di fronte alla sua sublime signoria? La polvere sollevata dagli zoccoli le aveva forse offuscato la vista?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hai ragione. Papà non parla mai male di Lavinia, e devi ammettere che tutti parlano male di Lavinia”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jane annuì distrattamente. In maniera incomprensibile, Lady Sarah non aveva ancora mostrato grande ammirazione per Lord Slade. “Non avete trovato Lord Slade straordinariamente bello?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah alzò di nuovo le spalle. “È... più vecchio di quello che normalmente trovo attraente”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lui non ha nemmeno trent’anni!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ed io non ne ho ancora diciotto!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Allora sei attratto dai giovani più vicini ai diciott’anni?” "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Molto particolare")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah annuì. “Fino all’età di mio fratello”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lord Harry aveva ventidue anni. “Ma la maggior parte degli uomini di quell’età, a meno che non abbiano avuto la fortuna di avere successo, non sono in una posizione finanziaria tale da poter offrire per una moglie - - -” Miss Featherstone si batté la fronte. “Una simile considerazione, però, non è necessariamente per una signora con una grande fortuna”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Infatti. Posso sposare chi voglio”. Fece una sorriso stupendo e disse: “Mi sposerò entro settembre”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Se è questo che vuoi, sono certo che lo farai. Perché tanta fretta?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Adoro l’idea di avere una casa tutta mia. Non sarebbe meraviglioso sposare un uomo con un castello di famiglia? Con la mia fortuna potrei arredarlo come voglio. E adoro i bambini. Mi vedo circondata da bellissime figlie bionde”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“E i figli? O un marito?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lady Sarah Bertram arricciò il naso perfetto. “Immagino che mio marito si aspetterà che io gli dia un erede, anche se non amo molto i ragazzini. Certo, desidero un marito”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Forse lo incontrerete stasera”.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("* * *")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-c"
  }, [_vm._v("“C")]), _vm._v("hiedo a vostra signoria")]), _vm._v(" di fermarsi”, disse Lipton a Lord Slade.")]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Con un profondo sospiro, Slade raddrizzò il collo e scrutò il suo specchio a figura intera. Il suo uomo si affannava ad annodare la cravatta che Lipton aveva passato un bel po’ di tempo a stirare. Per Lipton era molto più importante che per Slade che il suo padrone avesse un aspetto ammirevole.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se Slade fosse stato libero di soddisfare solo se stesso, non sarebbe stato lì. Non sarebbe affatto andato al ballo degli Spencer. E non si sarebbe preparato ad offrirsi come il pescato del giorno al mercato del pesce di Billingsgate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ma il conte non era libero di compiacere se stesso. Adesso era il capo della famiglia. Doveva pensare agli altri. L’acquisto dei colori di David aveva quasi esaurito i suoi fondi limitati, e avrebbe dovuto rimandare l’uscita delle ragazze almeno di un altro anno.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Da quando la borsa aveva decimato la spuntata di suo padre, non c’erano abbastanza soldi nonostante tutte le sue misure di risparmio. Aveva affittato la casa di Londra e attualmente affittava stanze ad un indirizzo rispettabile. Aveva venduto la costosa carrozza e tre dei quattro cavalli che richiedeva. Lui ed i suoi fratelli occupavano solo un’ala del fatiscente castello di Dunvale, che adesso poteva essere gestito con un quarto della servitù rispetto a quando il vecchio conte era in vita.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il suo sguardo seguì le manipolazioni esperte di Lipton e si accigliò profondamente. Perché aveva fatto quel misero voto, il voto che avrebbe modificato irrevocabilmente il corso della sua vita?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quanto era stato felice prima di riuscirci. Fino a quando non aveva visto Miss Featherstone quel pomeriggio, aveva quasi dimenticato quanto gli fossero piaciute le vivaci discussioni Whig alle cene presiedute dal padre di quella straordinaria giovane donna. C’era più intelletto tra quelle modeste mura che in tutta la Camera dei Lord.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La porta del suo camerino si aprì e suo fratello entrò. Slade pensò che suo fratello – il Capitano David St. John – facesse una bella figura con la sua uniforme da Life Guards. Le donne sarebbero sicuramente andate in estasi per lui stasera. Lo facevano sempre.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Io pensai che Lipton si fosse preso un cazzotto in testa quando mi ha detto che stasera saresti andato al ballo da Lord Spencer”. David guardò Slade come se il fratello maggiore fosse un deficiente mentale. “Non sapevo che le debuttanti fossero il tuo forte”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Finora non lo erano”. Le labbra di Slade si incresparono in una linea cupa.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("David si colpì la fronte. “Oh, sì. Il giuramento”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lord Slade annuì quasi impercettibilmente, vide che Lipton non aveva lasciato nemmeno un granello di lanugine sulla sua giacca appena stirata di pettinato nero fine e fu soddisfatto del suo aspetto. Niente di troppo colorato per lui. Il bianco e nero andava benissimo. “Andiamo?” egli disse a David.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 72
// module chunks = 0